"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cryptoOptions = exports.tableEncryptionOptions = void 0;
exports.tableEncryptionOptions = {
    NON_INDEXED_FIELDS: 'NON_INDEXED_FIELDS',
    UNENCRYPTED_LIST: 'UNENCRYPTED_LIST',
    ENCRYPT_LIST: 'ENCRYPT_LIST',
};
exports.cryptoOptions = exports.tableEncryptionOptions;
//# sourceMappingURL=types.js.map